
  import { Component, Vue ,Prop,Watch } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  import * as echarts from 'echarts';
  @Component({  
    name: '',
    components: {
      PageFooter,
    }
  })

  export default class ProductList extends Vue {
    @Prop({default:()=>{return []}}) data:any
    @Prop({default:()=>{return {value:'value',name:'name'}}}) option!:any
    @Prop() title!:any
    @Watch('data')
    private watchdata(){
      this.$nextTick(()=>{
        this.initcharts()
      })
    }

    private key = Math.random()

    private mounted () {
    // console.log(this.option) 
      this.$nextTick(()=>{
        this.initcharts()
      })
    }
    private clearChart(){
      let myChart = echarts.init(document.getElementById('charts'+this.key))
      myChart.clear()
      myChart.setOption({})
    }
    private initcharts(){
      let chartDom = document.getElementById('charts'+this.key);
      let myChart = echarts.init(chartDom);
      let option = {
        // title: {
        //   text: this.title,
        //   subtext: 'Fake Data',
        //   left: 'center'
        // },
        tooltip: {
          trigger: 'item',
          formatter:(v)=>{
            // console.log(v)
            return v.marker + v.data.label + "：" + v.value
          }
        },
        legend: {
          // orient: 'vertical',
          top:'0%',
          left: 'center'
        },
        series: [
          {
            name:'',
            type: 'pie',
            radius: '50%',
            data: this.data.map(v=>{
              v.value = v[this.option.value]
              v.name = v[this.option.name]
              return v
            }),
            bottom:'-20%',
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            label:{
              formatter:"{b} : {d}%"
            }
          }
        ],
      };
      option && myChart.setOption(option);
    }
  }
